module.exports = __webpack_public_path__ + "static/media/terraza.141c79a2.png";